import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Walkaround, api } from "../../../logic/api";
import EditableGroup, { EditableGroupType } from "../../../components/editable/EditableGroup/EditableGroup";
import EditableField, { EditableFieldTypes } from "../../../components/editable/EditableField/EditableField";
import { CharacterCasing } from "../../../components/editable/EditableField/fields/TextInputField";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { SessionContext } from "../../../utility/useSession";
import { useTranslation } from "react-i18next";

export interface IWalkaroundEdit {
    show: boolean;
    onClose: (didUpdate: boolean, walkaround: Walkaround | null) => void;
    walkaround: Walkaround | null;
}
export const WalkaroundEdit: React.FC<IWalkaroundEdit> = (props) => {
    const save = api.hooks.walkaround.save();

    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [walkaround, setWalkaround] = useState<Walkaround | null>(props.walkaround == null ? null : { ...props.walkaround });

    useEffect(() => {
        setWalkaround(props.walkaround == null ? null : { ...props.walkaround });
    }, [props.walkaround]);

    const updateWalkaround = (wa: Walkaround) => {
        setWalkaround(wa);
        return true;
    };

    if (walkaround == null) return <Fragment />;

    return <Dialog open={props.show}>
        <DialogTitle>{t("walkarounds.editWalkaround")}</DialogTitle>
        <DialogContent>
            <EditableGroup<Walkaround>
                id="walkaround"
                testId="walkaround-edit-group"
                editType={EditableGroupType.alwaysEditing}
                data={walkaround}
                onDataChanged={(data) => Promise.resolve(updateWalkaround(data))}
            >
                <EditableField<Walkaround, string>
                    inputType={EditableFieldTypes.text}
                    label={t("input.labels.name")}
                    required={true}
                    maxLength={50}
                    showCharacterCount={true}
                    useFullWidthWhenEditing={true}
                    onProvide={(data) =>
                        data.name ?? ""
                    }
                    onChange={(data, value) => {
                        data.name = value;
                    }}
                />
                <EditableField<Walkaround, string>
                    inputType={EditableFieldTypes.text}
                    label={t("walkarounds.abbrev")}
                    useFullWidthWhenEditing={true}
                    showCharacterCount={true}
                    maxLength={3}
                    required={true}
                    casing={CharacterCasing.upper}
                    onProvide={(data) =>
                        (data.abbrev ?? "").toUpperCase()
                    }
                    onChange={(data, value) => data.abbrev = (value ?? "").toUpperCase()}
                />
            </EditableGroup>
            <ProgressDialog status={save.status}></ProgressDialog>
            <ErrorDialog err={save.err}></ErrorDialog>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => { props.onClose(false, null); }}>{t("general.close")}</Button>
            <Button onClick={() => {
                save.send(session.current.context, walkaround, (w) => {
                    if (w == null) return;
                    props.onClose(true, walkaround);
                });

            }}>{t("general.save")}</Button>
        </DialogActions>
    </Dialog>
};